<template>
  <the-modal @closeModal="closeModal" class="group-action-attn-modal">
    <div slot="header">
      <h3>{{ $t('booleanSearch.delete_attention.title') }}</h3>
      <div class="header-actions">
        <span class="close fas fa-times" v-on:click="closeModal"></span>
      </div>
    </div>
    <div slot="body">
      <div>
        {{ $t('booleanSearch.delete_attention.message') }}
        <div v-html="queryLists" />
      </div>
    </div>
    <div slot="footer">
      <div class="btn-container text-right">
        <button class="btn btn-danger mr10" :class="{disabled: isBusy}" tabindex="0" v-on:click="deleteResource">
          <i class="far fa-spinner-third fa-spin" v-if="isBusy" />
          <span v-else>{{ $t("booleanSearch.delete_attention.try_again") }}</span>
        </button>
        <button class="btn btn-default" tabindex="1" v-on:click="(e) => closeModal(e)">
          {{ $t("confirmation.cancel") }}
        </button>
      </div>
    </div>
  </the-modal>
</template>

<script>
// Plugins
import { mapState } from 'vuex'
import { find } from 'lodash'

import theModal from '../../modal.vue'

//Config
import { searchTypes, multiSyntaxSearch } from "../../../config/bool-const";

export default {
  name: "GroupActionAttnModal",

  computed: {
    ...mapState({
      groupBlocked: state => state.booleanSearch.group_blocked,
      groupLibrary: state => state.booleanSearch.group_library
    }),

    queryLists () {
      let listString = '';
      let url = `/clients/${this.$route.params.client_id}/projects/${this.$route.params.project_id}/searches/`;

      if(this.groupBlocked.searches.length > 0) {
        listString += `<span class="list-header"><b>Queries</b></span><ul class="list">`;

        this.groupBlocked.searches.forEach(search => {
          listString += `<li><div class="dot display-inline" style="${this.dotColour(search)}"></div><a href="${url + search.id}" target="_blank">${search.name || 'ID: ' + search.id}</a></li>`
        });

        listString += '</ul>'
      }

      if(this.groupBlocked.groups.length > 0) {
        listString += `<span class="list-header"><b>Groups</b></span><ul class="list">`;

        this.groupBlocked.groups.forEach(group => {
          listString += `<li><div class="dot display-inline" style="${this.dotColour(group, true)}"></div><a href="${url + 'group_library/' + group.id}" target="_blank">${group.name}</a></li>`
        });

        listString += '</ul>'
      }

      return listString;
    },

    isBusy () {
      return this.groupLibrary.deletedQuery && this.groupLibrary.deletedQuery.id === this.groupBlocked.group_id
    }
  },

  methods: {
    deleteResource () {
      this.$emit('onRetry');
    },

    closeModal() {
      this.$store.commit('booleanSearch/SET_GROUP_RENAME_DELETE_REFUSED', {});
    },

    dotColour(item, isGroup = false) {
      let color;

      if(isGroup) {
        color = '#9CA3AF';
      }
      else if(item.is_multi){
        color = multiSyntaxSearch.color;
      }
      else {
        let searchTypeOptions = find(searchTypes, type => type.value === item.search_type);
        color = searchTypeOptions && searchTypeOptions.color && searchTypeOptions.color.trim() !== '' ? searchTypeOptions.color : '#754cf5';
      }

      return `background-color: ${color};`
    }
  },

  components: {
    theModal
  }
}
</script>

<style lang="scss">
  .boolean-search-layout .group-action-attn-modal {
    .modal-body {
      .list {
        margin: 5px 0 10px 0;

        .dot {
          margin-right: .4rem;
        }

        li a {
          color: $gray-500;

          &:hover {
            color: $carma-teal;
          }
        }
      }
    }

  .modal-footer {
    .btn-container .btn {
        width: auto;
      display: inline-block;
      height: 32px;
      line-height: 32px;
      min-width: 5rem;
      }
    }
  }
</style>